import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  APIResponse,
} from '../newPublications/VideoThumbnail';
import {
  fetchJSON,
} from '../Utils';
import {
  youtubeAPI,
} from '../Utils';

// Taken from:
// https://www.smashingmagazine.com/2014/02/making-embedded-content-work-in-responsive-design/#responsive-iframe-video
const VideoWrapper = styled.div`
  position: relative;
  padding-top: 55vh;
  height: 0;
  overflow: hidden;
  max-height: 350px;

  & iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;
const Root = styled.div`
  border: 1px solid #ccc;
  width: 100%;
  margin-bottom: 4vh;
`;

interface Props {
  id: string;
  getFooter?: (title: string, channel: string) => React.ReactNode;
  onSucccesfulLoad: () => void;
}

const YoutubeVideo = (props: Props) => {
  const {id, getFooter, onSucccesfulLoad} = props;
  interface VideoInfo {
    channelTitle: string; title: string; id: string;
  }

  const [videoInfo, setVideoInfo] = useState<undefined | VideoInfo>(undefined);
  useEffect(() => {
    const fetchData = async () => {
      const requestURL = new URL(youtubeAPI);
      requestURL.searchParams.set('id', id);
      requestURL.searchParams.set('part', 'snippet');
      requestURL.searchParams.set('key', GOOGLE_API_KEY);

      try {
        const json = await fetchJSON<APIResponse>(requestURL.href);
        const info = json.items[0];
        const {snippet: {title, channelTitle}} = info;
        setVideoInfo({id, title, channelTitle});
        onSucccesfulLoad();
      } catch (e) {
        throw new Error(e);
      }
    };
    fetchData();
  }, [id]);

  const videoTitle = (videoInfo === undefined) ? '' : videoInfo.title;
  const videoChannelTitle = (videoInfo === undefined) ? '' : videoInfo.channelTitle;
  const footer = (getFooter === undefined) ? null : getFooter(videoTitle, videoChannelTitle);

  return (
    <Root>
      <VideoWrapper>
        <iframe width='640' height='350'
          src={`https://www.youtube.com/embed/${id}`}
          frameBorder='0'
          allowFullScreen={true}/>
      </VideoWrapper>
      {footer}
    </Root>
  );
};

export default YoutubeVideo;
